import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LocalPharmacyIcon from "@material-ui/icons/LocalPharmacy";
import CameraIcon from "@material-ui/icons/Camera";
import OpacityIcon from "@material-ui/icons/Opacity";
import { PHARMACY_TYPES } from "../../../utils/pharmacyValidation";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
  },
  card: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "left",
    flex: "1 1 190px",
    minWidth: 0,
    padding: theme.spacing(2, 2, 2.25),
    border: "1.5px solid #dfe7ee",
    borderRadius: 14,
    background: "#fbfdff",
    cursor: "pointer",
    fontFamily: "inherit",
    appearance: "none",
    transition: "transform 180ms cubic-bezier(.22,.61,.36,1), box-shadow 180ms, border-color 180ms, background 180ms",
    "&:hover": {
      transform: "translateY(-3px)",
      borderColor: "#a9cbe4",
      boxShadow: "0 12px 24px -14px rgba(8, 82, 121, .45)",
    },
    "&:focus-visible": {
      outline: "none",
      borderColor: "#0077B6",
      boxShadow: "0 0 0 3px rgba(0, 119, 182, .25)",
    },
  },
  cardSelected: {
    borderColor: "#0077B6",
    background: "linear-gradient(160deg, #f0f8ff 0%, #ffffff 70%)",
    boxShadow: "0 14px 28px -16px rgba(8, 82, 121, .55)",
  },
  icon: {
    display: "grid",
    placeItems: "center",
    width: 38,
    height: 38,
    borderRadius: 11,
    background: "#e8f2fa",
    color: "#0077B6",
    marginBottom: theme.spacing(1.25),
    transition: "background 180ms, color 180ms",
  },
  iconSelected: {
    background: "#0077B6",
    color: "#fff",
  },
  label: {
    fontSize: "0.9375rem",
    fontWeight: 600,
    lineHeight: 1.25,
    color: "#0f3a52",
    marginBottom: 2,
  },
  description: {
    fontSize: "0.75rem",
    lineHeight: 1.45,
    color: "#6d8496",
  },
  check: {
    position: "absolute",
    top: 12,
    right: 12,
    color: "#0077B6",
    fontSize: "1.25rem !important",
  },
}));

const ICONS = {
  phar: LocalPharmacyIcon,
  img: CameraIcon,
  lab: OpacityIcon,
};

/**
 * The type of the place decides in which list of the prescription screen the
 * place shows up, so it is picked with cards instead of a dropdown.
 */
export default function PlaceTypePicker({ value, onChange, t, disabled }) {
  const classes = useStyles();

  return (
    <div className={classes.grid} role="radiogroup" aria-label={t("Type")}>
      {PHARMACY_TYPES.map((option) => {
        const Icon = ICONS[option.value];
        const selected = value === option.value;

        return (
          <button
            type="button"
            key={option.value}
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            className={`${classes.card} ${selected ? classes.cardSelected : ""}`}
            onClick={() => onChange(option.value)}
          >
            <span className={`${classes.icon} ${selected ? classes.iconSelected : ""}`}>
              <Icon fontSize="small" />
            </span>
            <span className={classes.label}>{t(option.label)}</span>
            <span className={classes.description}>{t(option.description)}</span>
            {selected && <CheckCircleIcon className={classes.check} />}
          </button>
        );
      })}
    </div>
  );
}
